import type { AllowedQueryParams } from './interfaces';
import { Products } from './productDefinition';

export enum Level {
  Group = 'group',
  Subgroup = 'subgroup',
  Monogram = 'monogram',
}

export enum sortList {
  Default = 'Default',
  Newest = 'Newest',
  PriceHighLow = 'Price: High - Low',
  PriceLowHigh = 'Price: Low - High',
}

export const Clients = {
  inStore: 'inStore',
  onLine: 'onLine',
};

export enum AddToBagError {
  F404 = 'F404', // Fabric not existing
  W500 = 'W500', // Webstore AddToCart Call Failing
  CM500 = 'CM500', // CM AddToBag call failing
}

export enum SaveFlows {
  SaveForLater = 'SaveForLater',
  FinishInStore = 'FinishInStore',
}

export enum ConfiguratorOrigin {
  Normal = 'Normal',
  Reorder = 'Reorder',
  SaveForLater = 'SaveForLater',
  FinishInStore = 'FinishInStore',
  Clone = 'Clone',
  CustomizeFlow = 'CustomizeFlow',
}

export type SaveFlowsType = keyof typeof SaveFlows;
export type ConfiguratorOriginsType = keyof typeof ConfiguratorOrigin;
export type AddToBagErrorType = keyof typeof AddToBagError;

export const allFabricsGroupId = 0;

export type ClientType = keyof typeof Clients;

export const MeasurementsCoatProductType = 'OuterwearFormal';

const supportedCountryCodes: string[] = [
  'AF',
  'AL',
  'DZ',
  'AS',
  'AD',
  'AO',
  'AI',
  'AG',
  'AR',
  'AM',
  'AW',
  'AU',
  'AT',
  'AZ',
  'BS',
  'BH',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BL',
  'BQ',
  'BA',
  'BW',
  'BR',
  'BN',
  'BG',
  'BF',
  'BI',
  'KH',
  'CM',
  'CA',
  'IC',
  'CV',
  'KY',
  'CF',
  'TD',
  'CL',
  'CN',
  'CO',
  'KM',
  'CG',
  'CD',
  'CK',
  'CR',
  'HR',
  'CU',
  'CW',
  'CY',
  'CZ',
  'DK',
  'DJ',
  'DM',
  'DO',
  'TL',
  'EC',
  'EG',
  'SV',
  'GQ',
  'ER',
  'EE',
  'ET',
  'FO',
  'FJ',
  'FI',
  'FR',
  'GF',
  'PF',
  'GA',
  'GM',
  'GE',
  'DE',
  'GH',
  'GI',
  'GR',
  'GL',
  'GD',
  'GP',
  'GU',
  'GT',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'HN',
  'HK',
  'HU',
  'IS',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IE',
  'IM',
  'IL',
  'IT',
  'CI',
  'JM',
  'JP',
  'JE',
  'JO',
  'KZ',
  'KE',
  'KI',
  'KW',
  'KG',
  'LA',
  'LV',
  'LB',
  'LS',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MO',
  'MK',
  'MG',
  'MW',
  'MY',
  'MV',
  'ML',
  'MT',
  'MH',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MS',
  'MA',
  'MZ',
  'NA',
  'NP',
  'NL',
  'NC',
  'NZ',
  'NI',
  'NE',
  'NG',
  'MP',
  'NO',
  'OM',
  'PK',
  'PW',
  'PS',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PL',
  'PT',
  'PR',
  'QA',
  'RE',
  'RO',
  'RU',
  'RW',
  'WS',
  'SM',
  'SA',
  'SN',
  'RS',
  'SC',
  'SL',
  'SG',
  'SK',
  'SI',
  'SB',
  'SO',
  'ZA',
  'KR',
  'SS',
  'ES',
  'LK',
  'KN',
  'LC',
  'SX',
  'VC',
  'SD',
  'SR',
  'SZ',
  'SE',
  'CH',
  'SY',
  'TW',
  'TJ',
  'TZ',
  'TH',
  'TG',
  'TO',
  'TT',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'UA',
  'AE',
  'GB',
  'US',
  'UY',
  'UZ',
  'VU',
  'VE',
  'VN',
  'VG',
  'VI',
  'WF',
  'YE',
  'ZM',
  'ZW',
  'AX',
];

export const supportedLanguages: string[] = ['de', 'en', 'es', 'fr', 'it', 'pl', 'sv', 'zh', 'nl', 'ko'];

export const allowedQueryParams: AllowedQueryParams = {
  client: [Clients.onLine, Clients.inStore],
  product: Object.keys(Products),
  countryCode: supportedCountryCodes,
  language: supportedLanguages,
  identifier: [],
  preloadConfiguration: [],
  reorder: ['true', 'false', true, false],
  storeId: [],
  CustomerID: [],
  sessionId: [],
  productCode: [],
  fabricCode: [],
  sizeId: [],
  search: [true, false, 'true', 'false', '1', '0'],
  filterValues: [],
  origin: [
    ConfiguratorOrigin.Normal,
    ConfiguratorOrigin.Reorder,
    ConfiguratorOrigin.FinishInStore,
    ConfiguratorOrigin.SaveForLater,
    ConfiguratorOrigin.Clone,
    ConfiguratorOrigin.CustomizeFlow,
  ],
  configurationId: [],
  shareCode: [],
  subconfigurationId: [],
  appSwitcher: ['true', 'false', true, false],
  section: [],
};

export const pageIndicationQueryParams: { [key: string]: string } = {
  reorder: 'reorder',
  search: 'search',
};

export const stateStorageName = 'cm_state';
export const hiddenValuesStorageName = 'cm_hiddenValues';
export const stateExpiryStorageName = 'cm_state_exp';
export const storageTTL = 1000 * 60 * 60;

export const ZoomPosition: Record<string, number> = {
  None: 0,
  TopLeft: 1,
  TopCenter: 2,
  TopRight: 3,
  MiddleLeft: 4,
  MiddleCenter: 5,
  MiddleRight: 6,
  BottomLeft: 7,
  BottomCenter: 8,
  BottomRight: 9,
};

export const SidePanelSizes = {
  Mobile: 188, //height of the card for Mobile
  Tablet: 244, //height of the card for Tablet
  Desktop: 360, //width of the card for Desktop
  BigDesktop: 440 //width of the card for Big Desktop
}
